import {err} from 'framework';
import type {Result, UseCase, ValidationError} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {Workout} from '../../domain/workout';
import type {AddExerciseToWorkoutInput, WorkoutRepository} from '../ports/workout.repository';
import type {AddExerciseToWorkoutDataValidator} from '../validators/add-exercise-to-workout-data.validator';

export class AddExerciseToWorkout implements UseCase<[AddExerciseToWorkoutInput], Workout> {
  constructor(
    private readonly repository: WorkoutRepository,
    private readonly validator: AddExerciseToWorkoutDataValidator,
  ) {}

  execute(
    input: AddExerciseToWorkoutInput,
  ): Promise<Result<Workout, WorkoutError | ValidationError>> {
    const validated = this.validator.validate(input);
    if (!validated.ok) {
      return Promise.resolve(err(validated.error));
    }
    return this.repository.addExercise(validated.data);
  }
}
